export const BRAND = 'brand';
export const INVERSE = 'inverse';
export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';

export const DIVIDER_COLORS = Object.freeze([PRIMARY, SECONDARY, INVERSE, BRAND]);

export default {
  BRAND,
  DIVIDER_COLORS,
  INVERSE,
  PRIMARY,
  SECONDARY,
};
